import { useEffect, useState } from 'react'

const avatarCache = new Map()

export function useUserAvatarCache(kedo, userId) {
    const [avatarSrc, setAvatarSrc] = useState(avatarCache.get(userId) || null)

    useEffect(() => {
        if (!userId) return

        
        if (avatarCache.has(userId)) {
            setAvatarSrc(avatarCache.get(userId))
            return
        }

        kedo.api()
            .getCached(kedo.api().getUserEndpoint(userId))
            .then((response) => {
                if (response.data?.avatar?.length > 0) {
                    const avatarUrl = kedo
                        .api()
                        .getUserAvatarEndpoint(userId, response.data.avatar)

                    const img = new Image()
                    img.onload = () => {
                        avatarCache.set(userId, avatarUrl)
                        setAvatarSrc(avatarUrl)
                    }
                    img.src = avatarUrl
                }
            })
            .catch((err) => {
                console.error('Error fetching user avatar:', err)
            })
    }, [kedo, userId])

    return avatarSrc
}